import {
  PCMP_BATCH_STATUS_LABELS,
  PCMP_BATCH_STATUS_TONE,
} from '../../constants/pcmpMis.constants';
import type { PcmpMisBatch } from '../../types/pcmpMis.types';
import { PcmpStatusPill } from '../PcmpProposalDetail/PcmpStatusPill';

export function PcmpBatchStatusPill({ status }: { status: PcmpMisBatch['status'] }) {
  return (
    <PcmpStatusPill tone={PCMP_BATCH_STATUS_TONE[status]}>
      {PCMP_BATCH_STATUS_LABELS[status]}
    </PcmpStatusPill>
  );
}
